export default {
  user: {}
}



// WEBPACK FOOTER //
// ./src/store/state.js